module.exports = __webpack_public_path__ + "img/time-blue.dae5be8e.svg";